import { render, staticRenderFns } from "./StudentListFornWizard.vue?vue&type=template&id=3e7f74c2"
import script from "./StudentListFornWizard.vue?vue&type=script&lang=js"
export * from "./StudentListFornWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports